module.exports = __webpack_public_path__ + "static/media/copy.292e2824.svg";